/**
 * Version Utility Functions
 */

/**
 * Increment the patch version number (x.x.PATCH)
 * @param currentVersion - Current version string (e.g., "1.0.0")
 * @returns Incremented version string
 */
export const incrementVersion = (currentVersion?: string): string => {
  if (!currentVersion) return "1.0.0";

  const parts = currentVersion.split('.');
  if (parts.length !== 3) return "1.0.0";

  const major = parseInt(parts[0] || '0', 10);
  const minor = parseInt(parts[1] || '0', 10);
  const patch = parseInt(parts[2] || '0', 10);

  if (isNaN(major) || isNaN(minor) || isNaN(patch)) return "1.0.0";

  return `${major}.${minor}.${patch + 1}`;
};
